import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { isCanada } from 'app/common/websiteCountry';
import { Card, Menu, MenuItem } from '@progress/kendo-react-layout';
import { ic_account_language as IconLanguage } from 'app/widgets/SVGs';
import ArrowDownImage from '../../../assets/images/chevron_down.svg';
import { useNavigate } from 'react-router-dom';
import ClickOutside from 'app/widgets/ClickOutside';
import { useLanguageContext } from 'context';
import clsx from 'clsx';

export function LoginHeader() {
  const { t } = useTranslation();
  const { language, changeLanguage } = useLanguageContext();
  const [isLanguageExpanded, setIsLanguageExpanded] = React.useState(false);

  const navigate = useNavigate();

  const onNavigateClicked = item => {
    setIsLanguageExpanded(false);
    switch (item.item.data) {
      case 'language':
        setIsLanguageExpanded(() => !isLanguageExpanded);
        break;
    }
  };

  return (
    <>
      <span
        className={clsx('site-logo', { 'website-CA': isCanada })}
        onClick={() => {
          navigate('/login', {
            state: { showLandingPage: true },
          });
        }}
      >
        <img src="/logo.svg" alt="logo" />
      </span>
      <div className="landing-header">
        <ClickOutside
          onClickOutside={() => {
            return setIsLanguageExpanded(false);
          }}
        >
          <Menu vertical onSelect={onNavigateClicked} className="btn-display">
            <MenuItem
              data="language"
              render={() => (
                <div className="align-inline margin">
                  <span className="align-inline">
                    <span className="link-icon">{<IconLanguage />}</span>
                    <span className="link-text">
                      <div className="language-component language-menu-dropdown">
                        <span>
                          <span className="selected-language">
                            {language.toLocaleUpperCase().slice(0, 2)}
                          </span>
                        </span>
                        {isLanguageExpanded && (
                          <Card className="top-card top-card-language-setting language-menu-dropdown-options">
                            <div className="">
                              <span
                                onClick={() => {
                                  changeLanguage('en');
                                }}
                              >
                                {t('language_EN')}
                              </span>
                              <span
                                onClick={() => {
                                  changeLanguage('fr');
                                }}
                              >
                                {t('language_FR')}
                              </span>
                            </div>
                          </Card>
                        )}
                      </div>
                    </span>
                  </span>
                  <span className="link-arrow">
                    <img src={ArrowDownImage} alt="right arrow"></img>
                  </span>
                </div>
              )}
            />
          </Menu>
        </ClickOutside>
      </div>
    </>
  );
}
